import { Organization, User } from '@logic'
import { BuzzBootstrapInput } from '../types'

export function buildCanonicalBuzzInput(
  currentOrganization: Organization | undefined,
  currentUser: User | undefined,
  members: BuzzBootstrapInput['members'] = [],
  agents: BuzzBootstrapInput['agents'] = [],
): BuzzBootstrapInput | null {
  if (!currentOrganization?.id || !currentUser?.id) return null
  return {
    organization: { id: currentOrganization.id, name: currentOrganization.name },
    currentUser: {
      id: currentUser.id,
      fullName: currentUser.profile?.fullName || currentUser.username || currentUser.id,
    },
    members,
    agents,
  }
}

export function buzzBootstrapSignature(input: BuzzBootstrapInput | null): string {
  if (!input) return ''
  return JSON.stringify({
    organization: input.organization,
    currentUser: input.currentUser,
    members: [...input.members].sort((left, right) => left.id.localeCompare(right.id)),
    agents: [...input.agents].sort((left, right) => left.id.localeCompare(right.id)),
  })
}
